import $ from 'jquery';
import WindowUtils from './utils/WindowUtils.js';
import { createScroll } from './core/ScrollService.js';
import { runPage } from './page.js';
import { initGravityFormsScrollSync, runLandingAttributionBridge } from './integrations/gravityForms.js';
import { initCustomSelect } from './features/customSelect.js';

jQuery = $;

const WU = new WindowUtils();
if (WU.isTouch()) {
    $('html').addClass('isTouch');
}
if (WU.isSafari()) {
    $('html').addClass('isSafari');
}

function initPage() {
    try {
        createScroll();
    } catch (error) {
        console.error('[silae] createScroll failed', error);
    }
    runPage();
    initGravityFormsScrollSync();
    runLandingAttributionBridge();
}

const boot = () => {
    initPage();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}

jQuery(document).on('gform_post_render', () => {
    initCustomSelect();
});
